import { Box, Button, Checkbox, FormControlLabel, IconButton, InputAdornment, Select, Tab, Tabs, TextField, Typography, BaseTextFieldProps, MenuItem, CircularProgress, Container, Stack, Avatar } from '@mui/material'
import React, { useState, useRef, useEffect } from 'react'
import { fb, linkdin, Logo, mail, microsoft, } from '../assets/images'
import { GoogleIcon, LinkedInsmallIcon, MicrosoftIcon, RightArrow, TickSymbolThin } from '../assets/icons'
import Grid from '@mui/material/Grid2'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import umbrellaSignBg from "../assets/images/umbrellaSignBg.png"
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import { CheckboxProps } from '@mui/material/Checkbox';
import 'react-international-phone/style.css';
import { CountryIso2, defaultCountries, FlagImage, parseCountry, usePhoneInput, } from 'react-international-phone';
import AuthService from '../services/auth.service'
import { useNavigate, useSearchParams } from 'react-router-dom'
import AccountVerification from '../modals/AccountVerification'
import moment from 'moment-timezone';
import { CardComponent } from "@chargebee/chargebee-js-react-wrapper";
import chargebeeService from '../services/chargebee.service'
import { Applications } from '../types/enums'
import { toast } from 'react-toastify'
import { SocialProvider } from '../types/auth'
import { config } from '../config'
import theme from '../theme'
import { automatedPriceMonthly, automatedPriceYearly, allInOnePriceMonthly, allInOnePriceYearly } from '../components/subscription/pricing/pricingData';
import { formatPlanName } from '../utils/common.util'
import { LeadsquaredService } from '../services/leadsquared/leadsquared.service'

// Add CheckCircleIcon component
const CheckCircleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
        <path d="M24.5459 11.6742C24.1194 11.2291 23.6786 10.7697 23.5014 10.342C23.3373 9.945 23.3286 9.35766 23.3188 8.73641C23.3034 7.71047 23.2859 6.54891 22.5072 5.77016C21.7284 4.99141 20.5625 4.97391 19.5409 4.95859C18.9197 4.94875 18.3378 4.94 17.9353 4.77594C17.5077 4.59875 17.0483 4.15797 16.6031 3.73141C15.8769 3.03578 15.0544 2.24609 14 2.24609C12.9456 2.24609 12.1231 3.03578 11.3969 3.73141C10.9517 4.15797 10.4923 4.59875 10.0647 4.77594C9.66766 4.94 9.08031 4.94875 8.45906 4.95859C7.43312 4.97391 6.27156 4.99141 5.49281 5.77016C4.71406 6.54891 4.69656 7.71484 4.68125 8.73641C4.67141 9.35766 4.66266 9.93953 4.49859 10.342C4.32141 10.7697 3.88063 11.2291 3.45406 11.6742C2.75844 12.4005 1.96875 13.223 1.96875 14.2773C1.96875 15.3317 2.75844 16.1542 3.45406 16.8805C3.88063 17.3256 4.32141 17.785 4.49859 18.2127C4.66266 18.6097 4.67141 19.197 4.68125 19.8183C4.69656 20.8442 4.71406 22.0058 5.49281 22.7845C6.27156 23.5633 7.4375 23.5808 8.45906 23.5961C9.08031 23.6059 9.66219 23.6147 10.0647 23.7787C10.4923 23.9559 10.9517 24.3967 11.3969 24.8233C12.1231 25.5189 12.9456 26.3086 14 26.3086C15.0544 26.3086 15.8769 25.5189 16.6031 24.8233C17.0483 24.3967 17.5077 23.9559 17.9353 23.7787C18.3323 23.6147 18.9197 23.6059 19.5409 23.5961C20.5669 23.5808 21.7284 23.5633 22.5072 22.7845C23.2859 22.0058 23.3034 20.8442 23.3188 19.8183C23.3286 19.197 23.3373 18.6152 23.5014 18.2127C23.6786 17.785 24.1194 17.3256 24.5459 16.8805C25.2416 16.1542 26.0312 15.3317 26.0312 14.2773C26.0312 13.223 25.2416 12.4005 24.5459 11.6742ZM23.5987 15.9727C23.088 16.5042 22.5597 17.0555 22.2862 17.7117C22.0259 18.3395 22.015 19.0811 22.0041 19.7986C21.992 20.6123 21.9789 21.4545 21.5775 21.857C21.1761 22.2595 20.3328 22.2716 19.5191 22.2836C18.8016 22.2945 18.06 22.3055 17.4322 22.5658C16.7759 22.837 16.2291 23.3653 15.692 23.8783C15.1178 24.4252 14.5239 24.9983 13.9978 24.9983C13.4717 24.9983 12.8778 24.4284 12.3025 23.8783C11.7709 23.3675 11.2197 22.8392 10.5634 22.5658C9.93563 22.3055 9.19406 22.2945 8.47656 22.2836C7.66281 22.2716 6.82062 22.2584 6.41813 21.857C6.01562 21.4556 6.00359 20.6123 5.99156 19.7986C5.98062 19.0811 5.96969 18.3395 5.70938 17.7117C5.43813 17.0555 4.90984 16.5086 4.39688 15.9716C3.85109 15.3973 3.28125 14.8034 3.28125 14.2773C3.28125 13.7513 3.85109 13.1573 4.40125 12.582C4.91203 12.0505 5.44031 11.4992 5.71375 10.843C5.97406 10.2152 5.985 9.47359 5.99594 8.75609C6.00797 7.94234 6.02109 7.10016 6.4225 6.69766C6.82391 6.29516 7.66719 6.28312 8.48094 6.27109C9.19844 6.26016 9.94 6.24922 10.5678 5.98891C11.2241 5.71766 11.7709 5.18938 12.308 4.67641C12.88 4.12844 13.4739 3.55859 14 3.55859C14.5261 3.55859 15.12 4.12844 15.6953 4.67859C16.2269 5.18938 16.7781 5.71766 17.4344 5.99109C18.0622 6.25141 18.8037 6.26234 19.5212 6.27328C20.335 6.28531 21.1772 6.29844 21.5797 6.69984C21.9822 7.10125 21.9942 7.94453 22.0063 8.75828C22.0172 9.47578 22.0281 10.2173 22.2884 10.8452C22.5597 11.5014 23.088 12.0483 23.6009 12.5853C24.1478 13.1595 24.7209 13.7534 24.7209 14.2795C24.7209 14.8056 24.1489 15.3973 23.5987 15.9727ZM18.8388 11.1886C18.9616 11.3116 19.0307 11.4784 19.0307 11.6523C19.0307 11.8263 18.9616 11.993 18.8388 12.1161L12.7137 18.2411C12.5907 18.364 12.4239 18.433 12.25 18.433C12.0761 18.433 11.9093 18.364 11.7863 18.2411L9.16125 15.6161C9.04533 15.4917 8.98222 15.3272 8.98522 15.1571C8.98822 14.9871 9.0571 14.8249 9.17733 14.7047C9.29757 14.5844 9.45978 14.5156 9.62979 14.5126C9.79981 14.5096 9.96435 14.5727 10.0887 14.6886L12.25 16.8487L17.9112 11.1886C18.0343 11.0657 18.2011 10.9967 18.375 10.9967C18.5489 10.9967 18.7157 11.0657 18.8388 11.1886Z" fill="black" />
    </svg>
);

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export interface MUIPhoneProps extends BaseTextFieldProps {
    value: string;
    onChange: (phone: string) => void;
}

export const MuiPhone: React.FC<MUIPhoneProps> = ({
    value,
    onChange,
    ...restProps
}) => {
    const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } =
        usePhoneInput({
            defaultCountry: 'us',
            value,
            countries: defaultCountries,
            onChange: (data) => {
                onChange(data.phone);
            },
            disableCountryGuess: true,
            forceDialCode: true,
        });

    return (
        <TextField
            variant="outlined"
            label="Phone number"
            color="primary"
            placeholder="Phone number"
            value={inputValue}
            onChange={handlePhoneValueChange}
            type="tel"
            inputRef={inputRef}
            sx={{
                "& .MuiOutlinedInput-root": {
                    borderRadius: '3px',
                    borderColor: '#666666',
                },

                " .MuiInputLabel-root.Mui-focused": {
                    color: "inherit",
                },

                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: '#333333',
                    border: '1px solid'
                },

                "& .MuiOutlinedInput-input": {
                    padding: '14px 16px',
                    background: '#ffffff',
                    borderRadius: '8px'
                },
                "&.MuiInputBase-input::placeholder": {
                    color: '#333333',
                    fontSize: '16px',
                    opacity: '0.8'
                },
            }}

            slotProps={{
                input: {
                    startAdornment: <InputAdornment
                        position="start"
                        style={{ marginRight: '2px', marginLeft: '-8px' }}
                    >
                        <Select
                            MenuProps={{
                                style: {
                                    height: '300px',
                                    width: '360px',
                                    top: '10px',
                                    left: '-34px',
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                },
                            }}
                            sx={{
                                width: 'max-content',
                                fieldset: {
                                    display: 'none',
                                },
                                '&.Mui-focused:has(div[aria-expanded="false"])': {
                                    fieldset: {
                                        display: 'block',
                                    },
                                },
                                '.MuiSelect-select': {
                                    padding: '8px',
                                    paddingRight: '24px !important',
                                },
                                svg: {
                                    right: 0,
                                },
                            }}
                            value={country.iso2}
                            onChange={(e) => setCountry(e.target.value as CountryIso2)}
                            renderValue={(value) => (
                                <FlagImage iso2={value} style={{ display: 'flex' }} />
                            )}
                        >
                            {defaultCountries.map((c) => {
                                const country = parseCountry(c);
                                return (
                                    <MenuItem key={country.iso2} value={country.iso2}>
                                        <FlagImage
                                            iso2={country.iso2}
                                            style={{ marginRight: '8px' }}
                                        />
                                        <Typography marginRight="8px">{country.name}</Typography>
                                        <Typography color="gray">+{country.dialCode}</Typography>
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </InputAdornment>
                },
            }}
            {...restProps}
        />
    );
};

const Signup = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = React.useState(false);
    const [showPromoField, setShowPromoField] = useState(false);
    const [value, setValue] = React.useState(0);
    const [phone, setPhone] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [termsError, setTermsError] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [leadSquaredId, setLeadSquaredId] = useState<string>('');
    const [cards] = useState([
        {
            name: "Amy Porterfield",
            title: "Online Marketing Expert",
            testimonial: "“I personally use EasyWebinar and they are the best. I moved from using other platforms and nothing compares to their reliability and customer support!”",
            avatar: "https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/Amy-Porterfield-circle-img.png"
        },
        {
            name: "Jessica Catorc",
            title: "Teachable",
            testimonial: "“With EasyWebinar you understand the people you're serving - which means you're thinking of the things they need. It's not just flashy software, it's what is important and what is vital for someone to grow their business.”",
            avatar: "https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/jessica-catorc-circle-img.png"
        },
        {
            name: "Ryan Fenn",
            title: "CEO & Founder of Chiirp",
            testimonial: "“We made 2 million dollars using EasyWebinar. We created one webinar, one time, and ran it for 3 years. We went from needing 6 sales reps to only 1 'order taker' using EasyWebinar as the sales engine.”",
            avatar: "https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/ryen-fenn-circle-img.png"
        }
    ]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % cards.length);
        }, 10000);

        return () => clearInterval(interval);
    }, [cards.length]);

    const handleDotClick = (index: number) => {
        setCurrentIndex(index);
    };

    const getTimezoneString = () => {
        const timezone = moment.tz.guess() || 'UTC';
        const offset = moment.tz(timezone).format('Z');
        const zoneName = moment.tz(timezone).zoneName();
        return `(GMT${offset}),${timezone},${zoneName}`;
    };

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        timezone: getTimezoneString(),
        subdomain: ''
    });
    const [formErrors, setFormErrors] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        password: '',
        subdomain: ''
    });
    const [phoneBlurred, setPhoneBlurred] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isCardReady, setIsCardReady] = useState(false);

    const [verificationData, setVerificationData] = useState({
        companyId: '',
        companyName: '',
        infLeadSquaredId: ''
    });

    const [cardToken, setCardToken] = useState<string>("");
    const [cardError, setCardError] = useState<string | null>(null);
    const cardRef = useRef<any>(null);

    const [searchParams, setSearchParams] = useSearchParams();
    const [planDetails, setPlanDetails] = useState<any>(null);
    const [isLoadingPlan, setIsLoadingPlan] = useState(false);

    const [promoCode, setPromoCode] = useState('');
    const [appliedPromo, setAppliedPromo] = useState<{
        code: string;
        discount: number;
        type: string;
    } | null>(null);
    const [promoError, setPromoError] = useState('');

    const [domainSuggestions, setDomainSuggestions] = useState<string[]>([]);

    const planId = searchParams.get('planId');
    const cleanPlanId = planId?.replace(/-\d+$/, '');

    // Set default planId if not present
    useEffect(() => {
        if (!planId) {
            // Use setSearchParams to update only the planId without reloading the page
            setSearchParams(prev => {
                prev.set('planId', 'All-In-One-USD-Monthly-100');
                return prev;
            });
        }
    }, [planId, setSearchParams]);

    useEffect(() => {
        const fetchPlanDetails = async () => {
            if (!cleanPlanId) return;

            setIsLoadingPlan(true);
            try {
                const response = await chargebeeService.getPlanById(cleanPlanId);
                setPlanDetails(response.data);
            } catch (error) {
                console.error('Failed to fetch plan details:', error);
            } finally {
                setIsLoadingPlan(false);
            }
        };

        fetchPlanDetails();
    }, [cleanPlanId]);

    useEffect(() => {
        // Extract plan details from planId and console log them
        if (planId) {

            // First, check if it's an All-In-One plan
            let extractedPlanType: string, currency: string, duration: string, extractedAttendees: number, extractedLiveAttendees: number | undefined;

            if (planId.startsWith('All-In-One')) {
                // For All-In-One plans
                const parts = planId.split('-');
                extractedPlanType = 'All-In-One';
                currency = parts[3]; // USD
                duration = parts[4]; // Yearly

                // For All-In-One, the first number is leads, second is live attendees
                if (parts.length > 6) {
                    // Format: All-In-One-USD-Yearly-6000-1000
                    extractedAttendees = parseInt(parts[5]); // 6000 (leads)
                    extractedLiveAttendees = parseInt(parts[6]); // 1000 (live attendees)
                } else {
                    // Format: All-In-One-USD-Yearly-6000
                    extractedAttendees = parseInt(parts[5]); // 6000 (leads)
                    // Default live attendees based on leads using a more efficient approach
                    const attendeeTiers = [
                        { max: 100, live: 50 },
                        { max: 300, live: 100 },
                        { max: 1000, live: 500 },
                        { max: 3000, live: 1000 },
                        { max: 6000, live: 2000 }
                    ];

                    const tier = attendeeTiers.find(tier => extractedAttendees <= tier.max);
                    extractedLiveAttendees = tier ? tier.live : 2000; // Default to 2000 for 6000+
                }
            } else {
                // For Automated-Gold plans
                const parts = planId.split('-');
                extractedPlanType = parts[0] + '-' + parts[1]; // Automated-Gold
                currency = parts[2]; // USD
                duration = parts[3]; // Yearly
                extractedAttendees = parseInt(parts[4]); // 10000
            }

            console.log("planid", extractedPlanType, currency, duration, extractedAttendees, extractedLiveAttendees);

            // Get pricing data based on plan type and duration
            let pricingData;
            if (extractedPlanType === 'Automated-Gold') {
                pricingData = duration === 'Yearly' ? automatedPriceYearly : automatedPriceMonthly;
            } else if (extractedPlanType === 'All-In-One') {
                pricingData = duration === 'Yearly' ? allInOnePriceYearly : allInOnePriceMonthly;
            } else {
                console.log('Unknown plan type:', extractedPlanType);
                return;
            }

            // Find the matching tier
            const tierKey = Object.keys(pricingData).find(key => {
                if (key.includes('+')) {
                    return extractedAttendees >= parseInt(key.replace('+', ''));
                }
                return parseInt(key) === extractedAttendees;
            });

            if (!tierKey) {
                console.log('No matching tier found for attendees:', extractedAttendees);
                return;
            }

            // Type assertion to tell TypeScript that tierKey is a valid key for pricingData
            const tierData = pricingData[tierKey as keyof typeof pricingData];

            const features = {
                planType: extractedPlanType,
                currency,
                duration,
                attendees: extractedAttendees,
                liveAttendees: extractedLiveAttendees,
                price: tierData.price,
                webinars: tierData.webinars,
                storage: tierData.storage,
            };

            console.log('Plan Features:', features);

            // Update all state variables at once to prevent multiple re-renders
            setPlanFeatures(features);
            setPlanType(extractedPlanType);
            setLeads(extractedAttendees);
            setLiveAttendees(extractedLiveAttendees);
            setPlanPrice(tierData.price);
            setPlanWebinars(tierData.webinars);
            setPlanStorage(tierData.storage);
        }
    }, [planId]);

    const getPlanPrice = () => {
        if (isLoadingPlan) return { original: 'Loading...', discounted: 'Loading...' };
        if (!planDetails) return { original: '$00.00/month', discounted: '$00.00/month' };

        const quantity = planId ? parseInt(planId.match(/-(\d+)$/)?.[1] || '0') : 0;

        const tier = planDetails.tiers.find((tier: any) => {
            if (!tier.ending_unit) {
                return quantity >= tier.starting_unit;
            }
            return quantity >= tier.starting_unit && quantity <= tier.ending_unit;
        });

        if (!tier) return { original: '$00.00/month', discounted: '$00.00/month' };

        const originalPrice = tier.price / 100; // Convert cents to dollars
        let discountedPrice = originalPrice;

        // Apply discount if promo code is applied
        if (appliedPromo) {
            if (appliedPromo.type === 'percentage') {
                discountedPrice = originalPrice * (1 - appliedPromo.discount / 100);
            } else if (appliedPromo.type === 'fixed_amount') {
                discountedPrice = Math.max(0, originalPrice - (appliedPromo.discount / 100));
            }
        }

        const period = planDetails.periodUnit;
        const displayOriginal = originalPrice;
        const displayDiscounted = discountedPrice;

        return {
            original: `$${Math.round(displayOriginal)}/${period}`,
            discounted: `$${Math.round(displayDiscounted)}/${period}`
        };
    };

    const validatePassword = (password: string) => {
        const minLength = 8;
        const hasNumber = /\d/.test(password);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

        if (password.length < minLength) {
            return 'Password must be at least 8 characters long';
        }
        if (!hasNumber) {
            return 'Password must contain at least one number';
        }
        if (!hasSpecialChar) {
            return 'Password must contain at least one special character';
        }
        return '';
    };

    const validatePhone = (phoneNumber: string) => {
        const digitsOnly = phoneNumber.replace(/\D/g, '');
        return digitsOnly.length >= 10 && digitsOnly.length <= 15;
    };

    const validateForm = () => {
        const errors = {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            password: '',
            subdomain: ''
        };
        let isValid = true;

        // Check required fields
        if (!formData.firstName.trim()) {
            errors.firstName = 'First name is required';
            isValid = false;
        }

        // Add lastName validation
        if (!formData.lastName.trim()) {
            errors.lastName = 'Last name is required';
            isValid = false;
        }

        if (!formData.email.trim()) {
            errors.email = 'Email is required';
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = 'Please enter a valid email';
            isValid = false;
        }

        if (!phone.trim()) {
            errors.phone = 'Phone number is required';
            isValid = false;
        } else if (!validatePhone(phone)) {
            errors.phone = 'Please enter a valid phone number';
            isValid = false;
        }

        // Password validation
        if (!formData.password.trim()) {
            errors.password = 'Password is required';
            setPasswordError('Password is required');
            isValid = false;
        } else {
            const passwordValidationError = validatePassword(formData.password);
            if (passwordValidationError) {
                errors.password = passwordValidationError;
                setPasswordError(passwordValidationError);
                isValid = false;
            } else {
                setPasswordError('');
            }
        }

        setFormErrors(errors);
        return isValid;
    };

    const isFormValid = () => {
        // Basic validation
        if (!validateForm()) return false;

        // Terms validation
        if (!acceptedTerms) {
            setTermsError('You must accept the terms of service to continue');
            return false;
        }

        return true;
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        // For subdomain field, convert to lowercase
        const processedValue = name === 'subdomain' ? value.toLowerCase() : value;

        // Update the form data with the raw input value
        setFormData(prev => ({
            ...prev,
            [name]: processedValue
        }));

        // Clear error when user starts typing
        setFormErrors(prev => ({
            ...prev,
            [name]: ''
        }));

        if (name === 'password') {
            if (!value.trim()) {
                setPasswordError('Password is required');
            } else {
                setPasswordError(validatePassword(value));
            }
        }
    };

    const handlePhoneChange = (value: string) => {
        setPhone(value);
        if (phoneBlurred) {
            setFormErrors(prev => ({
                ...prev,
                phone: value.trim() ? (validatePhone(value) ? '' : 'Please enter a valid phone number') : ''
            }));
        }
    };

    const handlePhoneBlur = () => {
        setPhoneBlurred(true);
        if (phone.trim()) {
            setFormErrors(prev => ({
                ...prev,
                phone: validatePhone(phone) ? '' : 'Please enter a valid phone number'
            }));
        }
    };

    const handleTermsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAcceptedTerms(event.target.checked);
        if (event.target.checked) {
            setTermsError('');
        }
    };

    const handleSignup = async () => {
        if (!validateForm()) {
            return;
        }

        setIsLoading(true);
        try {

            const signupData = {
                ...formData,
                phoneNumber: phone,
                timezone: getTimezoneString(),
                planId: planDetails.id,
                cardToken: cardToken,
                couponId: appliedPromo?.code
            };

            const response = await AuthService.signup(signupData);
            // Store the response data
            setVerificationData({
                companyId: response.data.companyId || '',
                companyName: response.data.companyName || '',
                infLeadSquaredId: response.data.inf_lead_squared_id || ''
            });
            handleVerificationDialogOpen();
        } catch (error) {
            console.error('Signup failed:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const [verificationDialogOpen, setVerificationDialogOpen] = React.useState(false);

    const handleVerificationDialogOpen = () => {
        setVerificationDialogOpen(true);
    };

    const handleVerificationDialogClose = async () => {
        setVerificationDialogOpen(false);
        const leadData = {
            "leadId": leadSquaredId,
            "fields": [
                { "Attribute": "mx_Plan_Name","Value": cleanPlanId},
                { "Attribute": "mx_Status","Value": "Pending Verification"}
            ]
        }
        await LeadsquaredService.updateLsField(leadData);
        navigate('/login');
    };

    const handleVerificationDialogProceed = async () => {
        // handleVerificationDialogClose();
        setVerificationDialogOpen(false);
        await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Email Verified" });
        const leadData = {
            "leadId": leadSquaredId,
            "fields": [
                { "Attribute": "mx_Plan_Name","Value": cleanPlanId},
                { "Attribute": "mx_Status","Value": "Active"}
            ]
        }
        await LeadsquaredService.updateLsField(leadData);
        navigate(`/loading-dashboard?ew_email=${formData.email}&planId=${planId}`);
    };

    const BpIcon = styled('span')(({ theme }) => ({
        borderRadius: 4,
        width: 24,
        height: 24,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#fff',

        'input:hover ~ &': {
            border: '1px solid #666666',
        },
    }));

    const BpCheckedIcon = styled(BpIcon)({
        '&::before': {
            display: 'block',
            width: 24,
            height: 24,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fillRule='evenodd' clipRule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input ~ &': {
            backgroundColor: '#178EFC',
            border: 'none',
        },

        'input:hover ~ &': {
            border: 'none',
        }
    });

    function BpCheckbox(props: CheckboxProps) {
        return (
            <Checkbox
                sx={{ '&:hover': { bgcolor: 'transparent' } }}
                disableRipple
                color="default"
                checkedIcon={<BpCheckedIcon />}
                icon={<BpIcon />}
                {...props}
            />
        );
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        // Only allow changing to the second tab (newValue = 1) if it's done programmatically
        // Users can always go back to the first tab (newValue = 0)
        if (newValue === 0) {
            setValue(newValue);
        }
        // The second tab (newValue = 1) can only be reached through handleNext function
        // which validates the form fields first
    }

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleSocialSignIn = (provider: SocialProvider) => {
        try {
            const googleAuthUrl = config.sso_auth_url;
            const planIdParam = searchParams.get('planId');

            // Create state parameter with additional metadata
            const stateData = {
                isRegistration: true,
                timestamp: Date.now(),
                ...(planIdParam && { planId: planIdParam }) // Only include planId if it exists
            };

            const baseParams = {
                client_id: config.sso_client_id,
                response_type: 'code',
                scope: 'email openid profile phone',
                redirect_uri: `${window.location.origin}/auth/sso/callback`,
                state: JSON.stringify(stateData),
                prompt: 'select_account'
            };

            const params = new URLSearchParams({
                ...baseParams,
                identity_provider: provider,
            });

            window.location.href = `${googleAuthUrl}?${params.toString()}`;
        } catch (error) {
            console.error('Google Sign In Error:', error);
            toast.error('Failed to initialize Google Sign In');
        }
    };

    const handleGoogleSignIn = () => handleSocialSignIn('Google');
    const handleMicrosoftSignIn = () => handleSocialSignIn('Microsoft');
    const handleLinkedinSignIn = () => handleSocialSignIn('Linkedin');

    const handleNext = async () => {
        // Force validation and display errors
        const isValid = validateForm();
        if (!isValid) {
            return;
        }

        setIsLoading(true);
        try {
            // Generate subdomain from first name and last name
            const baseSubdomain = (formData.firstName + formData.lastName).toLowerCase().trim().replace(/\s+/g, '');
            const subdomainResponse = await AuthService.generateSubdomain(baseSubdomain, Applications.EASYWEBINAR);

            // Store the generated subdomain for use in step 2
            setFormData(prev => ({
                ...prev,
                subdomain: subdomainResponse.subdomain
            }));

            // If validation and subdomain generation passes, move to second step
            setValue(1);
            const LsId = await LeadsquaredService.createtLead(formData, phone);
            await LeadsquaredService.joinActivity({ id: LsId, activityEvent: 201, activityValue: "Activity - EasyWebinar Purchase Attempt - Opted In" });
            setLeadSquaredId(LsId);

        } catch (error: any) {
            console.error('Error generating subdomain:', error);
            // You may want to show an error message to the user
        } finally {
            setIsLoading(false);
        }
    };

    const handleGetStarted = async () => {
        // Add domain validation here
        if (!formData.subdomain.trim()) {
            setFormErrors(prev => ({
                ...prev,
                subdomain: 'Domain is required'
            }));
            setDomainSuggestions([]);
            return;
        } else if (!/^[a-zA-Z0-9-]+$/.test(formData.subdomain)) {
            setFormErrors(prev => ({
                ...prev,
                subdomain: 'Domain can only contain letters, numbers, and hyphens'
            }));
            setDomainSuggestions([]);
            return;
        }

        if (!isFormValid()) return;

        try {
            setIsLoading(true);

            // Check domain availability first
            const domainResponse = await AuthService.checkSubDomainAvailability(
                formData.subdomain,
                Applications.EASYWEBINAR
            );

            if (!domainResponse.available) {
                setFormErrors(prev => ({
                    ...prev,
                    subdomain: 'This domain is already taken. Please try another one.'
                }));
                // Set domain suggestions if they exist
                if (domainResponse.suggestions && domainResponse.suggestions.length > 0) {
                    setDomainSuggestions(domainResponse.suggestions);
                } else {
                    setDomainSuggestions([]);
                }
                setIsLoading(false);
                return;
            }

            // Clear suggestions if domain is available
            setDomainSuggestions([]);

            let cardTokenResult = null;
            const planId = searchParams.get('planId');

            // Only process card if there's a plan
            if (planId) {
                const result = await cardRef.current.tokenize();

                if (result.error) {
                    setCardError(result.error.message || 'Card tokenization failed');
                    toast.error('Please check your card details.');
                    return;
                }

                cardTokenResult = result.token;
                setCardToken(cardTokenResult);
                setCardError(null);

                if (!cardTokenResult) {
                    setCardError('Please enter valid card details');
                    toast.error('Please enter valid card details');
                    return false;
                }
            }

            const signupData = {
                ...formData,
                phoneNumber: phone,
                timezone: getTimezoneString(),
                ...(planId && {
                    planId: planDetails.id,
                    planUnits: parseInt(planId?.match(/-(\d+)$/)?.[1] || '1') || 1,
                    cardToken: cardTokenResult,
                    couponId: appliedPromo?.code
                })
            };

            const response = await AuthService.signup(signupData);
            setVerificationData({
                companyId: response.data.companyId || '',
                companyName: response.data.companyName || '',
                infLeadSquaredId: response.data.inf_lead_squared_id || ''
            });
            handleVerificationDialogOpen();
            toast.success('Signup successful! Please verify your account.');
            await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Waiting To Confirm Email Validation" });
            await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: cleanPlanId });
            await LeadsquaredService.joinActivity({ id: leadSquaredId, activityEvent: 205, activityValue: "Currently In Trial" });
        } catch (error: any) {
            console.error('Signup failed:', error);
            setDomainSuggestions([]);
            if (error.name === 'INVALID_CARD') {
                setCardError('Please enter valid card details');
                toast.error('Invalid card details. Please try again.');
            } else {
                toast.error(error.message || 'An error occurred during signup. Please try again.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const validateCoupon = async () => {
        if (!promoCode.trim()) {
            setPromoError('Please enter a promo code');
            toast.error('Please enter a promo code');
            return;
        }

        try {
            const planId = searchParams.get('planId');
            const response = await chargebeeService.validateCoupon(
                promoCode,
                planId ? planId.replace(/-\d+$/, '') : undefined
            );

            if (response.data.valid) {
                const { coupon } = response.data;
                setAppliedPromo({
                    code: coupon.id,
                    discount: coupon.discountPercentage || coupon.discountAmount,
                    type: coupon.discountType
                });
                setPromoError('');
                setShowPromoField(false);
                toast.success('Promo code applied successfully!');
            } else {
                setPromoError(response.data.error || 'Invalid promo code');
                setAppliedPromo(null);
                toast.error(response.data.error || 'Invalid promo code');
            }
        } catch (error: any) {
            console.error('Error validating coupon:', error);
            setPromoError('Failed to validate promo code');
            setAppliedPromo(null);
            toast.error('Failed to validate promo code. Please try again.');
        }
    };

    // Inside the Signup component, add a state variable for planFeatures
    const [planFeatures, setPlanFeatures] = useState<{
        planType: string;
        currency: string;
        duration: string;
        attendees: number;
        liveAttendees?: number;
        price: number | string;
        webinars: number | string;
        storage: string;
    } | null>(null);

    // Add new state variables to store the extracted values
    const [planType, setPlanType] = useState<string>('');
    const [leads, setLeads] = useState<number>(0);
    const [liveAttendees, setLiveAttendees] = useState<number | undefined>(undefined);
    const [planPrice, setPlanPrice] = useState<number | string>('');
    const [planWebinars, setPlanWebinars] = useState<number | string>('');
    const [planStorage, setPlanStorage] = useState<string>('');

    return (
        <>
            <Box sx={{ background: "#FFFFFF", minHeight: "100vh", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", fontFamily: "Inter" }}>
                <Box sx={{ display: "flex" }} margin="auto" gap={{ xs: "20px", sm: "40px", md: "60px", lg: "100px" }}>
                    <Grid container width="100%" height="100%" minHeight="100vh" justifyContent="space-between">
                        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }} p={{ xs: "24px", md: "48px" }} mb={{ xs: "64px", md: "0px" }}>
                            <Box mb="24px" display="flex" justifyContent="space-between" alignItems="center">
                            <Box><img src={Logo} alt="logo" onClick={() => window.open("https://easywebinar.com/", "_blank")} style={{ cursor: "pointer" }}/></Box>
                                <Button
                                    variant="outlined"
                                    onClick={() => navigate('/login')}
                                    size="small"
                                    sx={{
                                        display: { xs: 'flex', sm: 'flex', md: 'none' },
                                        backgroundColor: "#F9F9F9",
                                        color: "#333333",
                                        borderColor: "#333333",
                                        border: "1px solid #CFCFCF",
                                        fontWeight: "700",
                                        textTransform: "capitalize",
                                        gap: "8px",
                                        "&:hover": {
                                            backgroundColor: "#F9F9F9",
                                            color: "#333333",
                                        },
                                        "& svg": {
                                            height: "16px",
                                        }
                                    }}>
                                    Login
                                    <RightArrow />
                                </Button></Box>
                            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" maxWidth="600px" margin="auto" marginTop="67px" zIndex={{ lg: '3' }} position="relative">
                                {value === 1 ? (
                                    <>
                                        <Typography
                                            color="#333333"
                                            fontWeight="700"
                                            fontSize={{ xs: "min(calc(18px + 6 * (100vw - 400px) / (1920 - 400)), 24px)", lg: "24px" }}
                                            mb="4px"
                                            textAlign="center"
                                        >
                                            {planId ? 'Enter payment details to get started' : 'Enter Payment Details'}
                                        </Typography>
                                        <Box className="login-authenticator-wrapper">
                                            <Box
                                                className="ew-copyright"
                                                sx={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: { xs: "20px", md: "unset" },
                                                    justifyContent: { xs: "center" },
                                                    alignItems: 'center',
                                                    padding: '0 !important',
                                                    position: 'unset!important',
                                                    mx: '0px!important',
                                                }}
                                            >
                                                <Box
                                                    component="ul"
                                                    sx={{
                                                        display: 'flex',
                                                        listStyle: 'none',
                                                        margin: 0,
                                                        padding: 0,
                                                        gap: '4px',
                                                        position: 'relative',
                                                        "li::after": {
                                                            display: "none"
                                                        }
                                                    }}
                                                >
                                                    <Box
                                                        component="li"
                                                        sx={{ paddingLeft: "0!important" }}
                                                        color="#666666"
                                                        fontSize="14px"
                                                        textAlign="center"
                                                        fontFamily="inter"
                                                        lineHeight="1.7 !important"
                                                    >
                                                        {planId ? `Enjoy full access. You won't be charged until your 14-day trial ends.` : "Pick a unique URL for your webinar platform. This will be your brand's home on EasyWebinar."}
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </>
                                ) : (
                                    <>
                                        <Typography
                                            color="#333333"
                                            fontWeight="700"
                                            fontSize="24px"
                                            mb="8px"
                                            textAlign="center"
                                        >
                                            Start Your Free 14-Day Trial
                                        </Typography>
                                        <Box display="flex" gap="12px" mb="24px" flexWrap="wrap" justifyContent="center" alignItems="center">
                                            {planId ? (
                                                <>
                                                    <Typography
                                                        color="#666666"
                                                        fontSize="14px"
                                                    >
                                                        Set up in minutes
                                                    </Typography>
                                                    <Box borderRadius="50%" width="4px" height="4px" sx={{ background: "#666" }}></Box>
                                                    <Typography
                                                        color="#666666"
                                                        fontSize="14px"
                                                    >
                                                        Cancel anytime
                                                    </Typography>
                                                </>
                                            ) : (
                                                <Typography
                                                    color="#666666"
                                                    fontSize="14px"
                                                >
                                                    No Credit Card Required
                                                </Typography>
                                            )}
                                        </Box>
                                    </>
                                )}

                                <Box sx={{ width: '100%' }} className="umbrella-signIn-tabs">
                                    <Box sx={{ display: "flex", justifyContent: "center", height: "4px" }}>
                                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                            <Tab {...a11yProps(0)} sx={{
                                                '& .MuiButtonBase-root.MuiTab-root.Mui-selected': {
                                                    color: '#178EFC !important',
                                                },
                                                '&.MuiTabs-indicator': {
                                                    backgroundColor: '#178EFC !important',
                                                },
                                            }} />
                                            <Tab {...a11yProps(1)} disabled={value !== 1} />
                                        </Tabs>
                                    </Box>
                                    <CustomTabPanel value={value} index={0}>
                                        {/* -----------commented below code as per the requirement---------- */}
                                        <Box width="100%" textAlign="center" mb="24px">
                                            <Box display="flex" mb="14px" justifyContent="center" flexWrap="wrap" gap="12px">
                                                <Box height={{ xs: "38px", sm: "42px" }} minWidth={{ xs: "fit-content", sm: "138px" }} px={{ xs: "12px", sm: "20px" }} borderRadius="2.747px" display="flex" alignItems="center" justifyContent="center" border="1px solid #D0D5DD" sx={{ cursor: "pointer", "&:hover": { bgcolor: "#f7f7f7" } }} onClick={handleGoogleSignIn}>
                                                    <Box mr={{ xs: "8px" }} display="flex"><GoogleIcon /></Box>
                                                    <Typography variant="body1" color="#0C141D">Google</Typography>
                                                </Box>
                                                <Box height={{ xs: "38px", sm: "42px" }} minWidth={{ xs: "fit-content", sm: "138px" }} px={{ xs: "12px", sm: "20px" }} borderRadius="2.747px" display="flex" alignItems="center" justifyContent="center" border="1px solid #D0D5DD" sx={{ cursor: "pointer", "&:hover": { bgcolor: "#f7f7f7" } }} onClick={handleLinkedinSignIn}>
                                                    <Box mr={{ xs: "8px" }} display="flex"><LinkedInsmallIcon /></Box>
                                                    <Typography variant="body1" color="#0C141D">Linkedin</Typography>
                                                </Box>
                                                {/* <Box height={{ xs: "38px", sm: "42px" }} minWidth={{ xs: "fit-content", sm: "138px" }} px={{ xs: "12px", sm: "20px" }} borderRadius="2.747px" display="flex" alignItems="center" justifyContent="center" border="1px solid #D0D5DD" sx={{ cursor: "pointer", "&:hover": { bgcolor: "#f7f7f7" } }}>
                                                    <Box mr={{ xs: "8px" }}><MicrosoftIcon /></Box>
                                                    <Typography variant="body1" color="#0C141D">Microsoft</Typography>
                                                </Box> */}
                                            </Box>
                                            <Box borderBottom="1px solid #D9D9D9" height="1px" position="relative" width={{ xs: "100%", sm: "76%" }} margin="24px auto 27px" > <Typography variant="body2" color="#667085" bgcolor="#ffffff" position="absolute" left="50%" sx={{ transform: "translate(-50%, -50%)" }} p="0 6px" whiteSpace="nowrap">Or  continue with email</Typography></Box>
                                        </Box>
                                        {/* -----------commented below code as per the requirement---------- */}

                                        <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }} mb={{ xs: "24px", sm: "48px" }}>
                                            <Grid size={{ xs: 12 }}>
                                                <TextField
                                                    variant="outlined"
                                                    label="Work email"
                                                    name="email"
                                                    placeholder="you@company.com"
                                                    value={formData.email}
                                                    onChange={handleInputChange}
                                                    error={!!formErrors.email}
                                                    helperText={formErrors.email}
                                                    sx={{
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: '3px',
                                                            borderColor: '#666666',
                                                        },

                                                        " .MuiInputLabel-root.Mui-focused": {
                                                            color: "inherit",
                                                        },

                                                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: '#333333',
                                                            border: '1px solid'
                                                        },

                                                        "& .MuiOutlinedInput-input": {
                                                            padding: '14px 16px',
                                                            background: '#ffffff',
                                                            borderRadius: '8px'
                                                        },
                                                        "&.MuiInputBase-input::placeholder": {
                                                            color: '#333333',
                                                            fontSize: '16px',
                                                            opacity: '0.8'
                                                        },
                                                    }}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6 }}>
                                                <TextField
                                                    variant="outlined"
                                                    label="First name"
                                                    name="firstName"
                                                    value={formData.firstName}
                                                    onChange={handleInputChange}
                                                    error={!!formErrors.firstName}
                                                    helperText={formErrors.firstName}
                                                    sx={{
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: '3px',
                                                            borderColor: '#666666',
                                                        },

                                                        " .MuiInputLabel-root.Mui-focused": {
                                                            color: "inherit",
                                                        },

                                                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: '#333333',
                                                            border: '1px solid'
                                                        },

                                                        "& .MuiOutlinedInput-input": {
                                                            padding: '14px 16px',
                                                            background: '#ffffff',
                                                            borderRadius: '8px'
                                                        },
                                                        "&.MuiInputBase-input::placeholder": {
                                                            color: '#333333',
                                                            fontSize: '16px',
                                                            opacity: '0.8'
                                                        },
                                                    }}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6 }}>
                                                <TextField
                                                    variant="outlined"
                                                    label="Last name"
                                                    name="lastName"
                                                    value={formData.lastName}
                                                    onChange={handleInputChange}
                                                    error={!!formErrors.lastName}
                                                    helperText={formErrors.lastName}
                                                    sx={{
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: '3px',
                                                            borderColor: '#666666',
                                                        },

                                                        " .MuiInputLabel-root.Mui-focused": {
                                                            color: "inherit",
                                                        },

                                                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: '#333333',
                                                            border: '1px solid'
                                                        },

                                                        "& .MuiOutlinedInput-input": {
                                                            padding: '14px 16px',
                                                            background: '#ffffff',
                                                            borderRadius: '8px'
                                                        },
                                                        "&.MuiInputBase-input::placeholder": {
                                                            color: '#333333',
                                                            fontSize: '16px',
                                                            opacity: '0.8'
                                                        },
                                                    }}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12 }}>
                                                <MuiPhone
                                                    value={phone}
                                                    onChange={handlePhoneChange}
                                                    onBlur={handlePhoneBlur}
                                                    error={!!formErrors.phone}
                                                    helperText={formErrors.phone}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12 }}>
                                                <TextField
                                                    variant="outlined"
                                                    label="Password"
                                                    type={showPassword ? 'text' : 'password'}
                                                    name="password"
                                                    value={formData.password}
                                                    onChange={handleInputChange}
                                                    error={!!passwordError}
                                                    helperText={passwordError}
                                                    sx={{
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: '3px',
                                                            borderColor: '#666666',
                                                            background: '#ffffff',
                                                            paddingRight: '0'
                                                        },

                                                        " .MuiInputLabel-root.Mui-focused": {
                                                            color: "inherit",
                                                        },

                                                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: '#333333',
                                                            border: '1px solid'
                                                        },

                                                        "& .MuiOutlinedInput-input": {
                                                            padding: '14px 16px',
                                                            background: '#ffffff',
                                                            borderRadius: '8px'
                                                        },
                                                        "&.MuiInputBase-input::placeholder": {
                                                            color: '#333333',
                                                            fontSize: '16px',
                                                            opacity: '0.8'
                                                        },
                                                    }}
                                                    slotProps={{
                                                        input: {
                                                            endAdornment: <InputAdornment position="start"><IconButton onClick={handleClickShowPassword}
                                                                sx={{ borderRadius: "2px", "&:hover": { backgroundColor: "unset" } }}
                                                                onMouseDown={handleMouseDownPassword}
                                                                onMouseUp={handleMouseUpPassword}  >
                                                                {!showPassword ? <Box display="flex" gap="4px" alignItems="center" color="#000000"><VisibilityIcon fontSize='small' />
                                                                    <Typography component="span" color="#000000" fontSize="14px">Show</Typography></Box>
                                                                    : <Box display="flex" gap="4px" alignItems="center" color="#000000">
                                                                        <VisibilityOffIcon fontSize='small'></VisibilityOffIcon> <Typography component="span" fontSize="14px">hide</Typography></Box>
                                                                }
                                                            </IconButton>
                                                            </InputAdornment>
                                                        },
                                                    }}
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid>
                                        <Button
                                            variant="contained"
                                            disableElevation
                                            disabled={isLoading}
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                textTransform: "unset",
                                                width: "100%",
                                                height: "51px",
                                                gap: "8px",
                                                fontSize: "16px",
                                                fontWeight: "500",
                                                margin: "auto",
                                                bgcolor: "#0382F7 !important",
                                                "&:hover": { bgcolor: "#006dd1 !important" },
                                                "&.Mui-disabled": {
                                                    bgcolor: "#178EFC !important",
                                                    opacity: 0.7
                                                }
                                            }}
                                            onClick={handleNext}
                                        >
                                            {isLoading ? (
                                                <CircularProgress size={24} sx={{ color: 'white' }} />
                                            ) : (
                                                'Start for Free'
                                            )}
                                        </Button>

                                        {value === 0 ? (
                                            <Box className="login-authenticator-wrapper" sx={{ position: "unset!important" }}>
                                                <Box
                                                    className="ew-copyright"
                                                    sx={{
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        gap: { xs: "20px" },
                                                        justifyContent: { xs: "center" },
                                                        alignItems: 'center',
                                                        padding: '0 !important',
                                                        position: 'unset!important',
                                                        margin: '16px 0 0 !important',
                                                    }}
                                                >
                                                    <Typography
                                                        component="span"
                                                        sx={{ paddingRight: "13px !important" }}
                                                        fontSize="12px !important"
                                                        color='#667085 !important'
                                                        borderRight={{ xs: "none !important", sm: "1px solid #c5c5c5 !important" }}
                                                    >
                                                        &copy; 2025 All Rights Reserved
                                                    </Typography>
                                                    <Box
                                                        component="ul"
                                                        sx={{
                                                            display: 'flex',
                                                            listStyle: 'none',
                                                            margin: 0,
                                                            padding: 0,
                                                            gap: '4px',
                                                            position: 'relative',
                                                            "li::after": {
                                                                background: "#667085 !important",
                                                            }
                                                        }}
                                                        flexWrap="wrap"
                                                        justifyContent="center"
                                                    >
                                                        <Box
                                                            component="li"
                                                            paddingLeft="0!important"
                                                        >
                                                            <Link
                                                                href="https://easywebinar.com/terms-conditions/"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className='terms'
                                                                sx={{
                                                                    textDecoration: 'none',
                                                                    color: '#667085 !important',
                                                                    fontSize: '12px !important',
                                                                    marginRight: "4px",

                                                                    '&:hover': {
                                                                        textDecoration: 'underline',
                                                                    },

                                                                }}
                                                            >
                                                                Terms of Service
                                                            </Link>
                                                        </Box>
                                                        <Box
                                                            component="li"
                                                        >
                                                            <Link
                                                                href="https://easywebinar.com/privacy/"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                sx={{
                                                                    textDecoration: 'none',
                                                                    color: '#667085 !important',
                                                                    fontSize: '12px !important',
                                                                    marginRight: "4px",
                                                                    '&:hover': {
                                                                        textDecoration: 'underline',
                                                                    },
                                                                }}
                                                            >
                                                                Privacy Policy
                                                            </Link>
                                                        </Box>
                                                        <Box
                                                            component="li"
                                                        >
                                                            <Link
                                                                href="https://easywebinar.com/cookies/"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                sx={{
                                                                    textDecoration: 'none',
                                                                    color: '#667085 !important',
                                                                    fontSize: '12px !important',
                                                                    '&:hover': {
                                                                        textDecoration: 'underline',
                                                                    },
                                                                }}
                                                            >
                                                                Security
                                                            </Link>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        ) : (
                                            <>
                                            </>
                                        )}

                                    </CustomTabPanel>

                                    <CustomTabPanel value={value} index={1}>
                                        {planId ? (
                                            <>
                                                <Box display="flex" justifyContent="space-between" marginBottom="20px" borderBottom="1px dashed #A3A3A3" paddingBottom="8px">
                                                    <Typography color="#2B2B30" fontSize="16px">
                                                        {planDetails?.name ? formatPlanName(planDetails?.id) : 'No plan selected'}
                                                    </Typography>
                                                    <Box display="flex" alignItems="center" gap={1}>
                                                        {appliedPromo && (
                                                            <Typography
                                                                color="#666666"
                                                                fontSize="16px"
                                                                sx={{ textDecoration: 'line-through' }}
                                                            >
                                                                {getPlanPrice().original}
                                                            </Typography>
                                                        )}
                                                        <Typography color={appliedPromo ? "#22B060" : "#2B2B30"} fontSize="16px">
                                                            {getPlanPrice().discounted}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                <Box display="flex" justifyContent="end" flexDirection="column">
                                                    {!showPromoField ? (
                                                        <>
                                                            {appliedPromo ? (
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '8px',
                                                                        padding: '4px 8px',
                                                                        backgroundColor: '#F0FFF4',
                                                                        borderRadius: '4px',
                                                                        width: 'fit-content',
                                                                        marginLeft: 'auto'
                                                                    }}
                                                                >
                                                                    <Typography color="#1D9652" fontSize="14px">
                                                                        {appliedPromo.code} applied
                                                                    </Typography>
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="16"
                                                                        height="16"
                                                                        viewBox="0 0 16 16"
                                                                        fill="none"
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={() => {
                                                                            setAppliedPromo(null);
                                                                            setPromoCode('');
                                                                        }}
                                                                    >
                                                                        <path d="M8 1C4.1 1 1 4.1 1 8C1 11.9 4.1 15 8 15C11.9 15 15 11.9 15 8C15 4.1 11.9 1 8 1ZM10.7 11.5L8 8.8L5.3 11.5L4.5 10.7L7.2 8L4.5 5.3L5.3 4.5L8 7.2L10.7 4.5L11.5 5.3L8.8 8L11.5 10.7L10.7 11.5Z" fill="#1D9652" />
                                                                    </svg>
                                                                </Box>
                                                            ) : (
                                                                <Typography
                                                                    color="#2B2B30"
                                                                    fontSize="16px"
                                                                    display="flex"
                                                                    justifyContent="end"
                                                                    sx={{
                                                                        cursor: 'pointer',
                                                                        '&:hover': {
                                                                            textDecoration: 'underline'
                                                                        }
                                                                    }}
                                                                    onClick={() => setShowPromoField(true)}
                                                                >
                                                                    Have a promo code?
                                                                </Typography>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <TextField
                                                            variant="outlined"
                                                            placeholder="Promo Code:"
                                                            value={promoCode}
                                                            onChange={(e) => {
                                                                setPromoCode(e.target.value);
                                                                setPromoError('');
                                                            }}
                                                            error={!!promoError}
                                                            helperText={promoError}
                                                            sx={{
                                                                width: "100%",
                                                                marginBottom: "25px",
                                                                "& .MuiOutlinedInput-root": {
                                                                    borderRadius: '3px',
                                                                    borderColor: '#C7C7C7',
                                                                    background: '#ffffff',
                                                                    paddingRight: '0'
                                                                },
                                                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                    borderColor: '#333333',
                                                                    border: '1px solid'
                                                                },
                                                                "& .MuiOutlinedInput-input": {
                                                                    padding: '14px 16px',
                                                                    background: '#ffffff',
                                                                    borderRadius: '8px'
                                                                },
                                                                "&.MuiInputBase-input::placeholder": {
                                                                    color: '#333333',
                                                                    fontSize: '16px',
                                                                    opacity: '0.8'
                                                                },
                                                            }}
                                                            slotProps={{
                                                                input: {
                                                                    endAdornment: (
                                                                        <InputAdornment
                                                                            position="end"
                                                                            sx={{
                                                                                ".MuiTypography-root": {
                                                                                    color: "#333333",
                                                                                    fontWeight: "500",
                                                                                    fontSize: "16px",
                                                                                },
                                                                                paddingRight: "10px",
                                                                            }}
                                                                        >
                                                                            <Box display="flex" justifyContent="center" alignItems="center">
                                                                                <Box
                                                                                    sx={{
                                                                                        background: '#67C68F',
                                                                                        borderRadius: '4px',
                                                                                        padding: '4px 10px',
                                                                                        marginRight: '4px',
                                                                                        minWidth: '57px',
                                                                                        fontSize: '14px',
                                                                                        fontWeight: '500',
                                                                                        color: '#fff',
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                    onClick={validateCoupon}
                                                                                >
                                                                                    Apply
                                                                                </Box>
                                                                                <svg
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width="17"
                                                                                    height="16"
                                                                                    viewBox="0 0 17 16"
                                                                                    fill="none"
                                                                                    style={{ cursor: 'pointer' }}
                                                                                    onClick={() => {
                                                                                        setShowPromoField(false);
                                                                                        setPromoError('');
                                                                                    }}
                                                                                >
                                                                                    <path d="M8.07324 1C4.17324 1 1.07324 4.1 1.07324 8C1.07324 11.9 4.17324 15 8.07324 15C11.9732 15 15.0732 11.9 15.0732 8C15.0732 4.1 11.9732 1 8.07324 1ZM10.7732 11.5L8.07324 8.8L5.37324 11.5L4.57324 10.7L7.27324 8L4.57324 5.3L5.37324 4.5L8.07324 7.2L10.7732 4.5L11.5732 5.3L8.87324 8L11.5732 10.7L10.7732 11.5Z" fill="#A3A3A3" />
                                                                                </svg>
                                                                            </Box>
                                                                        </InputAdornment>
                                                                    ),
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                </Box>
                                                <Box width="100%" mb="24px">
                                                    <Typography color="#333333" fontSize="14px" fontWeight="500" mb="12px">
                                                        Card Details
                                                    </Typography>
                                                    <Box width="100%" sx={{
                                                        "& .CbHosted": {
                                                            borderRadius: '3px',
                                                            border: '1px solid rgba(0, 0, 0, 0.23)',
                                                            padding: '14px 16px',
                                                            "&:hover, &--focus": {
                                                                borderColor: '#666666',
                                                            }
                                                        }
                                                    }}>
                                                        <CardComponent
                                                            ref={cardRef}
                                                            currency="USD"
                                                            showTestCards={true}
                                                            styles={{
                                                                border: "1px solid #666666",
                                                                base: {
                                                                    padding: "14px 16px",
                                                                    border: "1px solid #666666",
                                                                    fontSize: '16px',
                                                                    fontFamily: 'Inter, sans-serif',
                                                                    color: '#333333',
                                                                    '::placeholder': {
                                                                        color: '#667085',
                                                                    },
                                                                },
                                                                invalid: {
                                                                    color: '#ff0000',
                                                                },
                                                            }}
                                                            onChange={(status: any) => {
                                                                if (status.error) {
                                                                    setCardError(status.error.message);
                                                                } else {
                                                                    setCardError(null);
                                                                }
                                                            }}
                                                            onReady={() => {
                                                                console.log('Card component ready');
                                                                setIsCardReady(true);
                                                            }}
                                                            onBlur={() => {
                                                                console.log('Card component blurred');
                                                            }}
                                                            onFocus={() => {
                                                                console.log('Card component focused');
                                                            }}
                                                        />
                                                    </Box>
                                                    {cardError && (
                                                        <Typography color="error" fontSize="12px" mt={1}>
                                                            {cardError}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </>
                                        ) : null}
                                        <Box sx={{
                                            flex: 1, position: 'relative', '@media (max-width: 768px)': {
                                                width: '100%',
                                            }
                                        }} display="flex" flexDirection="column" justifyContent="space-between">
                                            <Box>
                                                <Box mb="8px">
                                                    <Typography color='#667085' fontSize='15px' marginBottom="18px">Your Custom URL</Typography>
                                                    <TextField
                                                        variant="outlined"
                                                        placeholder="https://your-brand.easywebinar.live"
                                                        value={formData.subdomain || ''}
                                                        onChange={(e) => {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                subdomain: e.target.value.toLowerCase()
                                                            }));
                                                            // Clear error when user starts typing
                                                            setFormErrors(prev => ({
                                                                ...prev,
                                                                subdomain: ''
                                                            }));
                                                        }}
                                                        error={!!formErrors.subdomain}
                                                        helperText={formErrors.subdomain}
                                                        sx={{
                                                            width: "100%",
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: '3px',
                                                                borderColor: '#C7C7C7',
                                                                background: '#ffffff',
                                                                paddingRight: '0'
                                                            },

                                                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: '#333333',
                                                                border: '1px solid'
                                                            },

                                                            "& .MuiOutlinedInput-input": {
                                                                padding: '11px 14px',
                                                                background: '#ffffff',
                                                                borderRadius: '8px'
                                                            },
                                                            "&.MuiInputBase-input::placeholder": {
                                                                color: '#333333',
                                                                fontSize: '16px',
                                                                opacity: '0.8'
                                                            },
                                                        }}
                                                        slotProps={{
                                                            input: {
                                                                endAdornment: (
                                                                    <InputAdornment
                                                                        position="end"
                                                                        sx={{
                                                                            ".MuiTypography-root": {
                                                                                color: "#333333",
                                                                                fontWeight: "500",
                                                                                fontSize: "16px",
                                                                            },

                                                                            paddingRight: "19px",
                                                                        }}
                                                                    >
                                                                        .easywebinar.live
                                                                    </InputAdornment>
                                                                ),
                                                            },
                                                        }}
                                                    />
                                                </Box>
                                                {domainSuggestions.length > 0 && (
                                                    <Box mt={1} mb={2}>
                                                        <Typography color="primary" fontSize="12px" mb={1}>
                                                            Available alternatives:
                                                        </Typography>
                                                        <Box display="flex" gap={0.5} flexWrap="wrap">
                                                            {domainSuggestions.map((suggestion, index) => (
                                                                <Button
                                                                    key={index}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            subdomain: suggestion
                                                                        }));
                                                                        setFormErrors(prev => ({
                                                                            ...prev,
                                                                            subdomain: ''
                                                                        }));
                                                                        setDomainSuggestions([]);
                                                                    }}
                                                                    sx={{
                                                                        textTransform: 'none',
                                                                        borderColor: '#D0D5DD',
                                                                        color: '#344054',
                                                                        padding: '2px 8px',
                                                                        minHeight: '24px',
                                                                        fontSize: '12px',
                                                                        '&:hover': {
                                                                            borderColor: '#667085',
                                                                            backgroundColor: '#F9FAFB'
                                                                        }
                                                                    }}
                                                                >
                                                                    {suggestion}
                                                                </Button>
                                                            ))}
                                                        </Box>
                                                    </Box>
                                                )}
                                                <Box marginTop="4px" mb={`min(52px, calc(32px + (52 - 32) * (100vw - 320px) / (1920 - 320)))`}>
                                                    <FormControlLabel
                                                        sx={{
                                                            fontSize: "14px",
                                                            color: "#333333",
                                                        }}
                                                        control={
                                                            <BpCheckbox
                                                                sx={{
                                                                    '& + span': {
                                                                        ml: '3px',
                                                                    },
                                                                    '& input + span': {
                                                                        height: "21px",
                                                                        width: "21px",
                                                                        "&:before": {
                                                                            width: "21px",
                                                                            height: "21px",
                                                                        }
                                                                    }
                                                                }}
                                                                checked={acceptedTerms}
                                                                onChange={handleTermsChange}
                                                            />
                                                        }
                                                        label={
                                                            <Typography color="#9CA3AF" fontSize="min(calc(12px + (14 - 12) * (100vw - 320px) / (1920 - 320)), 14px)">
                                                                I have read and agreed to the
                                                                <Link
                                                                    href="https://easywebinar.com/terms-conditions/"
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    sx={{
                                                                        textDecoration: 'none',
                                                                        color: '#22B060',
                                                                        fontSize: "min(calc(12px + (14 - 12) * (100vw - 320px) / (1920 - 320)), 14px)",
                                                                        display: 'inline',
                                                                        marginLeft: '4px',
                                                                        '&:hover': {
                                                                            textDecoration: 'underline',
                                                                        },
                                                                    }}
                                                                >
                                                                    Terms of Service
                                                                </Link>
                                                            </Typography>
                                                        }
                                                    />
                                                    {termsError && (
                                                        <Typography color="error" fontSize="12px" mt={1}>
                                                            {termsError}
                                                        </Typography>
                                                    )}
                                                </Box>
                                                {!planId && <Box borderRadius="8px" bgcolor="#EDF6FF" p="24px 12px" color="#5A5475" >
                                                    <Typography variant="body2" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)">URL Guidelines:</Typography>
                                                    <Box>
                                                        <Box component="ul" sx={{ "& li": { listStyle: "disc", fontSize: "min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" } }} pl="20px" mt="24px" lineHeight="1.5">
                                                            <Box component="li">
                                                                Use lowercase letters, numbers and hyphens only
                                                            </Box>
                                                            <Box component="li">
                                                                3-30 characters long
                                                            </Box>
                                                            <Box component="li">
                                                                No spaces or special characters
                                                            </Box>
                                                            <Box component="li">
                                                                Cannot start or end with a hyphen
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>}
                                                <Box display="flex" gap={{ xs: "13px", sm: "119px" }} justifyContent="center" alignItems="center" mt={{ xs: "20px", md: '42px' }}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={handleGetStarted}
                                                        className="x-large-btn"
                                                        disabled={isLoading}
                                                        disableElevation
                                                        fullWidth
                                                        sx={{
                                                            textTransform: "capitalize",
                                                            px: "44px",
                                                            height: "47px!important",
                                                            fontSize: "18px",
                                                            bgcolor: "#0382F7 !important",
                                                            "&:hover": { bgcolor: "#006dd1 !important" },
                                                        }}
                                                    >
                                                        {isLoading ? (
                                                            <CircularProgress size={24} sx={{ color: 'white' }} />
                                                        ) : (
                                                            'Get Started'
                                                        )}
                                                    </Button>
                                                </Box>
                                                <AccountVerification
                                                    onClose={handleVerificationDialogClose}
                                                    open={verificationDialogOpen}
                                                    onProceed={handleVerificationDialogProceed}
                                                    phoneNumber={phone}
                                                    email={formData.email}
                                                    companyId={verificationData.companyId}
                                                    companyName={verificationData.companyName}
                                                    infLeadSquaredId={verificationData.infLeadSquaredId}
                                                />
                                            </Box>
                                            <Box className="login-authenticator-wrapper" sx={{ position: "unset!important" }}>
                                                <Box
                                                    className="ew-copyright"
                                                    sx={{
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        gap: { xs: "20px" },
                                                        justifyContent: { xs: "center" },
                                                        alignItems: 'center',
                                                        padding: '0 !important',
                                                        position: 'unset!important',
                                                        margin: '56px 0 0 !important',
                                                    }}
                                                >
                                                    <Typography
                                                        component="span"
                                                        sx={{ paddingRight: "13px !important", fontWeight: "500" }}
                                                        fontSize="12px !important"
                                                        color='#667085 !important'
                                                        borderRight={{ xs: "none !important", sm: "1px solid #c5c5c5 !important" }}
                                                    >
                                                        &copy; 2025 All Rights Reserved
                                                    </Typography>
                                                    <Box
                                                        component="ul"
                                                        sx={{
                                                            display: 'flex',
                                                            listStyle: 'none',
                                                            margin: 0,
                                                            padding: 0,
                                                            gap: '4px',
                                                            position: 'relative',
                                                            "li::after": {
                                                                background: "#667085 !important",
                                                            }
                                                        }}
                                                        flexWrap="wrap"
                                                        justifyContent="center"
                                                    >
                                                        <Box
                                                            component="li"
                                                            paddingLeft={{ xs: "0!important" }}
                                                        >
                                                            <Link
                                                                href="https://easywebinar.com/terms-conditions/"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className='terms'
                                                                sx={{
                                                                    textDecoration: 'none',
                                                                    color: '#667085 !important',
                                                                    fontSize: '12px !important',
                                                                    fontWeight: "500",
                                                                    marginRight: "4px",

                                                                    '&:hover': {
                                                                        textDecoration: 'underline',
                                                                    },

                                                                }}
                                                            >
                                                                Terms of Service
                                                            </Link>
                                                        </Box>
                                                        <Box
                                                            component="li"
                                                        >
                                                            <Link
                                                                href="https://easywebinar.com/privacy/"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                sx={{
                                                                    textDecoration: 'none',
                                                                    color: '#667085 !important',
                                                                    fontSize: '12px !important',
                                                                    fontWeight: "500",
                                                                    marginRight: "4px",
                                                                    '&:hover': {
                                                                        textDecoration: 'underline',
                                                                    },
                                                                }}
                                                            >
                                                                Privacy Policy
                                                            </Link>
                                                        </Box>
                                                        <Box
                                                            component="li"
                                                        >
                                                            <Link
                                                                href="https://easywebinar.com/cookies/"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                sx={{
                                                                    textDecoration: 'none',
                                                                    fontWeight: "500",
                                                                    color: '#667085 !important',
                                                                    fontSize: '12px !important',
                                                                    '&:hover': {
                                                                        textDecoration: 'underline',
                                                                    },
                                                                }}
                                                            >
                                                                Security
                                                            </Link>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </CustomTabPanel>
                                </Box>
                            </Box >

                            {value === 0 ?
                                <Box display={{ xs: "none" }} maxWidth="600px" margin="auto" >
                                    <Stack spacing={`min(32px, calc(24px + 8 * (100vw - 320px) / (1920 - 320)))`} mt={`min(64px, calc(40px + 24 * (100vw - 320px) / (1920 - 320)))`}>
                                        <Box alignItems="center" borderRadius="12px" border="1px solid #E9E9E9" p={{ xs: "16px", sm: "22px" }}>
                                            <Box borderRadius="60px" bgcolor="#EDF6FF" mr="16px" mb="8px" maxWidth="40px" width="100%" height="40px" display="flex" alignItems="center" justifyContent="center" ><img src="https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/icons/funnel-icon.svg" alt="Automated Webinar Funnels" /></Box>
                                            <Box>
                                                <Typography variant="body1" color="initial" mb="4px" fontWeight="600">Automated Webinar Funnels</Typography>
                                                <Typography variant="body1" color="#4B5563">Convert 24/7 with automated webinars that feel live</Typography>
                                            </Box>
                                        </Box>
                                        <Box alignItems="center" borderRadius="12px" border="1px solid #E9E9E9" p={{ xs: "16px", sm: "22px" }}>
                                            <Box borderRadius="60px" bgcolor="#EDF6FF" mr="16px" mb="8px" maxWidth="40px" width="100%" height="40px" display="flex" alignItems="center" justifyContent="center" ><img src="https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/icons/bell-with-notification-icon.svg " alt="Real-time Engagement Tools" /></Box>
                                            <Box>
                                                <Typography variant="body1" color="initial" mb="4px" fontWeight="600">Real-time Engagement Tools</Typography>
                                                <Typography variant="body1" color="#4B5563">Boost attendance rates by 75% with smart notifications</Typography>
                                            </Box>
                                        </Box>
                                        <Box alignItems="center" borderRadius="12px" border="1px solid #E9E9E9" p={{ xs: "16px", sm: "22px" }}>
                                            <Box borderRadius="60px" bgcolor="#EDF6FF" mr="16px" mb="8px" maxWidth="40px" width="100%" height="40px" display="flex" alignItems="center" justifyContent="center" ><img src="https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/icons/analatics-icon.svg" alt="Advanced Analytics" /></Box>
                                            <Box>
                                                <Typography variant="body1" color="initial" mb="4px" fontWeight="600">Advanced Analytics</Typography>
                                                <Typography variant="body1" color="#4B5563">Track every metric that matters for optimization</Typography>
                                            </Box>
                                        </Box>
                                    </Stack>
                                    <Box display="flex" alignItems="center" flexWrap="wrap" justifyContent={{ xs: "center", md: "start" }} mt="40px" gap="min(40px, calc(24px + (40 - 24) * ((100vw - 320px) / (1920 - 320))))">
                                        <Box p="min(22px, calc(18px + (22 - 18) * ((100vw - 320px) / (1920 - 320))))" borderRadius="12px" bgcolor="#EDF6FF" display="flex" alignItems="center" gap="8px">
                                            <img src="https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/icons/single-star-icon.svg" alt="rating star" />
                                            <Box>
                                                <Typography variant="body2" color="#4B5563" mb="4px">4.3/5 Rating</Typography>
                                                <Box display="flex" alignItems="center" gap="8px"><Typography component="span" variant="body2" color="#9CA3AF">On</Typography><img src="https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/icons/g2-sm-icons.png" alt="g2 review" /></Box>
                                            </Box>
                                        </Box>
                                        <Box p="min(22px, calc(18px + (22 - 18) * ((100vw - 320px) / (1920 - 320))))" borderRadius="12px" bgcolor="#EDF6FF" display="flex" alignItems="center" gap="8px">
                                            <img src="https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/security-shield-img-mini.png" alt="Enterprise Ready" />
                                            <Box>
                                                <Typography variant="body2" color="#4B5563" mb="4px">Enterprise Ready</Typography>
                                                <Box display="flex" alignItems="center" gap="8px"><Typography component="span" variant="body2" color="#9CA3AF">GDPR compliance</Typography></Box>
                                            </Box>
                                        </Box>
                                    </Box></Box>
                                : ""}
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }} p={{ xs: "48px 24px", md: "48px" }} sx={{ background: "linear-gradient(180deg, #EEEEF1 66%, #535353 100%)" }} >
                            <Box display={{ xs: "none", md: "flex" }} justifyContent="flex-end">
                                <Button
                                    variant="outlined"
                                    onClick={() => navigate('/login')}
                                    size="large"
                                    sx={{
                                        backgroundColor: "#F9F9F9",
                                        color: "#333333",
                                        borderColor: "#333333",
                                        border: "1px solid #CFCFCF",
                                        fontWeight: "700",
                                        textTransform: "capitalize",
                                        gap: "8px",
                                        padding: "12px 20px",
                                        "&:hover": {
                                            backgroundColor: "#fbfbfb",
                                            color: "#333333",
                                        },
                                        "& svg": {
                                            height: "16px",
                                        }
                                    }}>
                                    Login
                                    <RightArrow />
                                </Button>
                            </Box>
                            <Box pt={{ xs: "0", md: "52px" }} maxWidth="641px" margin="auto" display={{ md: "block" }}>
                                <Typography variant="h2" color="initial" fontSize={`min(calc(28px + (36 - 28) * (100vw - 320px) / (1920 - 320)), 36px)`} mb="24px" fontWeight="700" lineHeight="1.3" maxWidth="min(calc(500px +  78* ((100vw - 320px) * 26 / 1600)), 641px)" textAlign={{ xs: "center", md: "unset" }} display={{ md: "block" }}>You've chosen <Typography component="span" color={theme.palette.primary.main} fontSize="inherit" fontWeight="inherit">{planType === "Automated-Gold" ? "Automated Gold Plan" : 'All-in-One Plan'}</Typography></Typography>
                                <Typography variant="subtitle1" color="#333333" textAlign={{ xs: "center", md: "unset" }} display={{ md: "block" }} maxWidth="582px">After your 14-day trial, you'll be charged <Typography component="span" color={theme.palette.primary.main} fontSize="inherit" fontWeight="700"></Typography> for a {planFeatures?.duration === 'Yearly' ? "full year" : "month"} of access. You can cancel anytime during the trial. </Typography>

                                <Box sx={{ mt: "32px", mb: "40px" }}>
                                    <Grid container spacing={{ xs: 1, sm: 2 }}>
                                        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                                <CheckCircleIcon />
                                                <Typography variant="body1" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" color="#333333">Up to {leads} leads</Typography>
                                            </Box>
                                        </Grid>
                                        {planType === "All-In-One" && <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                                <CheckCircleIcon />
                                                <Typography variant="body1" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" color="#333333">Unlimited live webinars</Typography>
                                            </Box>
                                        </Grid>}
                                        {planType === "Automated-Gold" && <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                                <CheckCircleIcon />
                                                <Typography variant="body1" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" color="#333333">Up to {planStorage} storage space</Typography>
                                            </Box>
                                        </Grid>}
                                        {planType === "All-In-One" && <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }} >
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                                <CheckCircleIcon />
                                                <Typography variant="body1" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" color="#333333">Up to {liveAttendees || 'X'} live attendees</Typography>
                                            </Box>
                                        </Grid>}
                                        <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                                <CheckCircleIcon />
                                                <Typography variant="body1" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" color="#333333">Up to {planWebinars} pre-recorded webinars</Typography>
                                            </Box>
                                        </Grid>
                                        {planType === "All-In-One" && <>
                                            <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }} >
                                                <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                                    <CheckCircleIcon />
                                                    <Typography variant="body1" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" color="#333333">Up to 4 presenters</Typography>
                                                </Box>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                                    <CheckCircleIcon />
                                                    <Typography variant="body1" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" color="#333333">Just in time</Typography>
                                                </Box>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                                    <CheckCircleIcon />
                                                    <Typography variant="body1" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" color="#333333">Data export & analytics</Typography>
                                                </Box>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }} >
                                                <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                                    <CheckCircleIcon />
                                                    <Typography variant="body1" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" color="#333333">On demand</Typography>
                                                </Box>
                                            </Grid>
                                        </>
                                        }
                                        {planType === "Automated-Gold" &&
                                            <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                                    <CheckCircleIcon />
                                                    <Typography variant="body1" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" color="#333333">Just in time</Typography>
                                                </Box>
                                            </Grid>
                                        }
                                        <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }} >
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                                <CheckCircleIcon />
                                                <Typography variant="body1" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" color="#333333">Simulated events+live chat</Typography>
                                            </Box>
                                        </Grid>
                                        {planType === "Automated-Gold" && <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                                <CheckCircleIcon />
                                                <Typography variant="body1" fontSize="min(calc(14px + (16 - 14) * (100vw - 320px) / (1920 - 320)), 16px)" color="#333333">Data export & analytics</Typography>
                                            </Box>
                                        </Grid>}


                                    </Grid>
                                </Box>

                                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center', gap: { xs: '16px', md: '30px' }, rowGap: "20px", mt: '40px', mb: '40px' }}>
                                    <img
                                        src="https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/foundr-logo.png"
                                        alt="Foundr"
                                        style={{ maxHeight: "35px", width: 'auto' }}
                                    />
                                    <img
                                        src="https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/aweber-logo.png"
                                        alt="AWeber"
                                        style={{ maxHeight: "35px", width: 'auto' }}
                                    />
                                    <img
                                        src="https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/teachable-logo.png"
                                        alt="Teachable"
                                        style={{ maxHeight: "35px", width: 'auto' }}
                                    />
                                    <img
                                        src="https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/bolby-logo.png"
                                        alt="Dolby"
                                        style={{ maxHeight: "35px", width: 'auto' }}
                                    />
                                    <img
                                        src="https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/keep-logo.png"
                                        alt="Keap"
                                        style={{ maxHeight: "35px", width: 'auto' }}
                                    />
                                </Box>
                                {/* carousel Section */}
                                <Box
                                    sx={{
                                        overflow: "hidden",
                                        width: "100%",
                                        margin: "auto",
                                        padding: { xs: "0", md: "24px 0 0" },
                                        position: "relative",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            transform: `translateX(-${currentIndex * 100}%)`,
                                            transition: "transform 0.5s ease-in-out",
                                            width: "100%"
                                        }}
                                    >
                                        <>{cards.map((card, index) => (
                                            <Box key={index} minWidth="100%">
                                                <Box
                                                    sx={{
                                                        backgroundColor: "#000000",
                                                        color: "#fff",
                                                        padding: { xs: "20px", sm: "18px 44px 22px 35px" },
                                                        borderRadius: "9px",
                                                        textAlign: "left",
                                                        display: "flex",
                                                        marginRight: "2px",
                                                        justifyContent: "space-between",
                                                        flexDirection: "column",
                                                        height: "100%",
                                                        width: "100%"
                                                    }}
                                                >
                                                    <Box>
                                                        <Typography color='#FAFAFA' fontSize='min(calc(14px + 2 * (100vw - 400px) / (1920 - 400)), 16px)' fontWeight='500'>{card.testimonial}</Typography>
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            marginTop: "12px",
                                                            justifyContent: "space-between",
                                                        }}
                                                    >
                                                        <Box display="flex">
                                                            <Avatar
                                                                src={card.avatar}
                                                                alt={card.name}
                                                                sx={{
                                                                    width: "min(calc(70px + 11 * (100vw - 400px) / (1920 - 400)), 81px)",
                                                                    height: "min(calc(70px + 11 * (100vw - 400px) / (1920 - 400)), 81px)",
                                                                    marginRight: "9px"
                                                                }}
                                                            />
                                                            <Box>
                                                                <Typography
                                                                    sx={{
                                                                        fontWeight: "500",
                                                                        color: "#FFFFFF",
                                                                        fontSize: `min(calc(16px + 2 * (100vw - 400px) / (1920 - 400)), 18px)`,
                                                                        mt: "8px"
                                                                    }}
                                                                >
                                                                    {card.name}
                                                                </Typography>
                                                                <Typography color="#B1B1B1" fontSize={`min(calc(14px + 2 * (100vw - 400px) / (1920 - 400)), 16px)`} sx={{ opacity: "60%" }}>
                                                                    {card.title}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        ))}
                                        </>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            marginTop: "24px",
                                            position: "absolute",
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            bottom: "12px",
                                        }}
                                    >
                                        {cards.map((_, index) => (
                                            <Box
                                                key={index}
                                                onClick={() => handleDotClick(index)}
                                                sx={{
                                                    width: "9px",
                                                    height: "9px",
                                                    borderRadius: "50%",
                                                    backgroundColor: index === currentIndex ? theme.palette.primary.main : "#CDCDCD",
                                                    marginRight: "6px",
                                                    cursor: "pointer",
                                                    transition: "background-color 0.3s ease, transform 0.3s ease",
                                                    "&:hover": {
                                                        transform: "scale(1.2)",
                                                    }
                                                }}
                                            />
                                        ))}
                                    </Box>

                                </Box>
                            </Box>
                        </Grid>

                    </Grid >
                </Box >
            </Box >
        </>
    )
}
export default Signup
